<template>
  <header class="header">
    <div class="header__inner">
      <a href="/" class="header__logo"><img src="/common/img/logo.png" alt="資格・通信教育講座のユーキャン" width="314" height="106"></a>
      <div class="header__nav-pc">
        <nav class="nav-pc">
          <ul class="nav-pc__list">
              <li class="nav-pc__item"><a href="https://help.u-can.co.jp/?il=[question]diagnosis_headmenu" class="nav-pc__link">よくある質問</a></li><!--
          --><li class="nav-pc__item"><a href="https://help.u-can.co.jp/faq/show/17/?il=[delivery]diagnosis_headmenu" class="nav-pc__link">配送/支払/返品について</a></li><!--
          --><li class="nav-pc__item"><a href="/company/reference.html?il=[reference]diagnosis_headmenu" class="nav-pc__link">お問合せ窓口</a></li>
          </ul>
        </nav>
      </div>
      <div class="header__nav">
        <div :class="[gnav, navStatus]">
          <div class="gnav__ham gnav__ham--out" @click="navOpen">
          <span class="gnav__part"></span><span class="gnav__part"></span><span class="gnav__part"></span>
          </div>
          <nav>
            <div class="gnav__inner">
              <dl class="gnav-list">
                <dt class="gnav-list__category">講座を探す</dt>
                <dd class="gnav-list__item">
                  <ul class="gnav-links">
                    <li class="gnav-links__item gnav-links__item--search">
                      <div class="search">
                        <div class="search__form">
                          <form name="searchForm" method="post" action="https://www.u-can.co.jp/offpc/CourseSearchList.do" accept-charset="Shift_JIS">
                            <input type="text" value="" class="search__text" placeholder="講座名・資格名を入力" name="strKeyWord" autocomplete="off" @keyup="searchWord" @focus="focus">
                            <input type="hidden" value="search" name="strSearchFlg">
                            <button type="submit" class="search__btn" value="検索" onclick="document.charset='SHIFT-JIS';" ref="submitBtn"><span class="search__magnify"></span></button>
                          </form>

                          <ul class="search-suggest" v-show="onSuggest">
                            <li v-for="list in filteredLists" :key="list.seq" class="search-suggest__item" @click="changeVal">
                            {{ list.name }}
                            </li>
                          </ul>

                        </div>
                      </div>
                    </li><!--
                  --><li class="gnav-links__item"><a href="/course/" class="gnav-links__link">全講座一覧</a></li><!--
                  --><li class="gnav-links__item"><a href="/special/rank/" class="gnav-links__link">人気講座ランキング</a></li>
                  </ul>
                </dd>

                <dt class="gnav-list__category">各種お申込み</dt>
                <dd class="gnav-list__item">
                  <ul class="gnav-links">
                    <li class="gnav-links__item"><a href="https://www.u-can.co.jp/offpc/StudyinfoRLAdd.do" class="gnav-links__link">資料請求はこちら</a></li><!--
                --><li class="gnav-links__item"><a href="https://www.u-can.co.jp/offpc/StudyinfoApply.do" class="gnav-links__link">お申込みはこちら</a></li><!--
                --><li class="gnav-links__item"><a href="https://lbl.u-can.jp/ap/id/identification.php" class="gnav-links__link">案内資料をお持ちの方はこちら</a></li>
                  </ul>
                </dd>

                <dt class="gnav-list__category">各種ヘルプ</dt>
                <dd class="gnav-list__item">
                  <ul class="gnav-links">
                    <li class="gnav-links__item"><a href="https://help.u-can.co.jp/?il=[question]diagnosis_headmenu" class="gnav-links__link">よくある質問</a></li><!--
                --><li class="gnav-links__item"><a href="https://help.u-can.co.jp/faq/show/17/?il=[delivery]diagnosis_headmenu" class="gnav-links__link">配送/支払/返品について</a></li><!--
                --><li class="gnav-links__item"><a href="/company/reference.html?il=[reference]diagnosis_headmenu" class="gnav-links__link">お問合せ窓口</a></li><!--
                --><li class="gnav-links__item"><a href="/?il=[top]diagnosis_headmenu" class="gnav-links__link">サイトトップへ戻る</a></li>
                  </ul>
                </dd>
              </dl>
            </div>
          </nav>
        </div>
        <div class="overlay"></div>
      </div>
    </div>
  </header>
</template>


<script>
import axios from 'axios'

let allLists = []

export default {
  name: 'Header',

  data: () => {
    return {
      gnav: 'gnav',
      navStatus: 'is-close',

      // suggest
      onSuggest: true,
      suggestLists: [],

      // 絞り込みテキスト
      filteredLists: [],
    }
  },

  created: function() {
    // 一覧を取得する
    this.fetchSuggestList()
  },

  methods: {
    navOpen: function() {
      let navStatus = this.navStatus
      if(navStatus == 'is-open') {
        this.navStatus = 'is-close'
        //inputを空にする
        document.querySelector('input[name="strKeyWord"]').value = ''

        window.changeClass()
      }else {
        this.navStatus = 'is-open'
        window.changeClass()
      }
    },

    // autocomplete.json取得
    fetchSuggestList: function() {
      //axios.get('/diagnosis/data/autocomplete.json') 開発用
      axios.get('/sys/smp/data/autocomplete.json')
        .then(response => {
          // console.log(response)
          const data = response.data
          this.suggestLists = data
          allLists = data
          // console.log('== this.suggestList ==')
          // console.log(this.suggestList)
        })
        .catch(function(error) {
          console.log(error);
        })
    },

    searchWord: function(e){
      this.suggestLists = allLists
      // console.log(Array.isArray(this.suggestLists))

      const newList = this.suggestLists.filter(function(list) {
        return list.kana.indexOf(e.target.value.trim()) !== -1
      })
      // console.log(newList)
      this.filteredLists = newList
    },

    changeVal: function(e) {
      document.querySelector('input[name="strKeyWord"]').value = e.target.innerText
      //ここで、falseにする
      this.onSuggest = false
      this.$refs.submitBtn.focus()
    },

    focus: function() {
      // console.log('focus')
      this.onSuggest = true
    }
  }
}
</script>


<style scoped>
</style>